import { Component, OnInit, Input, ElementRef, OnChanges, SimpleChanges, AfterViewInit } from "@angular/core";
import { ROUTES } from "../sidebar/sidebar.component";
import { Router, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from "ngx-toastr";
import { Location, LocationStrategy, PathLocationStrategy } from "@angular/common";
import { AuthService } from "src/app/auth.service";
import { CustomToastService } from "src/app/services/toast.service";
import { BsModalService } from 'ngx-bootstrap/modal';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';
@Component({ standalone: false,
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() bgColor: string = '';
  public listTitles!: any[];
  public location: Location;
  sidenavOpen: boolean = true;
  userDetails: any;
  username: any;

  // --- Profile Photo ---
  showProfileModal: boolean = false;
  profilePhotoUrl: string | null = null;

  constructor(
    location: Location,
    private router: Router,
    private adminService: AdminService,
    private authService: AuthService,
    public toastr: CustomToastService,
    private el: ElementRef,
    private modalService: BsModalService
  ) {
    this.location = location;
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        if (window.innerWidth < 1200) {
          document.body.classList.remove("g-sidenav-pinned");
          document.body.classList.add("g-sidenav-hidden");
          this.sidenavOpen = false;
        }
      }
      if (event instanceof NavigationError) {
        console.log(event.error);
      }
    });
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    this.userDetails = this.authService.getSession();
    this.username = this.authService.getUsername();
    this.profilePhotoUrl = this.authService.getProfileImageUrl();
    window.addEventListener("sidenav-closed", () => {
      this.sidenavOpen = false;
    });
    window.addEventListener("resize", () => this.applyNavColor());
  }

  ngAfterViewInit(): void {
    this.applyNavColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bgColor']) {
      this.applyNavColor();
    }
  }

  private applyNavColor(): void {
    const nav = this.el.nativeElement.querySelector('#navbar-main');
    if (!nav) return;

    const isMobileOrTablet = window.innerWidth < 768;

    if (isMobileOrTablet) {
      // Force the mobile/tablet brand color regardless of bgColor input
      nav.style.setProperty('background-color', '#444444', 'important');
      return;
    }

    if (this.bgColor) {
      nav.style.setProperty('background-color', this.bgColor, 'important');
    } else {
      nav.style.removeProperty('background-color');
    }
  }
  // ── Profile Photo ─────────────────────────────────────────────────────────

  onProfileDropdownToggle(isOpen: boolean): void {
    this.showProfileModal = isOpen;
  }

  onPhotoUpdated(newUrl: string): void {
    this.profilePhotoUrl = newUrl;
  }

  // ── Navigation ────────────────────────────────────────────────────────────

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }
    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "Dashboard";
  }

  openChangePasswordModal(): void {
    this.modalService.show(ChangePasswordModalComponent, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  openSearch() {
    document.body.classList.add("g-navbar-search-showing");
    setTimeout(function() {
      document.body.classList.remove("g-navbar-search-showing");
      document.body.classList.add("g-navbar-search-show");
    }, 150);
    setTimeout(function() {
      document.body.classList.add("g-navbar-search-shown");
    }, 300);
  }

  closeSearch() {
    document.body.classList.remove("g-navbar-search-shown");
    setTimeout(function() {
      document.body.classList.remove("g-navbar-search-show");
      document.body.classList.add("g-navbar-search-hiding");
    }, 150);
    setTimeout(function() {
      document.body.classList.remove("g-navbar-search-hiding");
      document.body.classList.add("g-navbar-search-hidden");
    }, 300);
    setTimeout(function() {
      document.body.classList.remove("g-navbar-search-hidden");
    }, 500);
  }

  openSidebar() {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
      this.sidenavOpen = false;
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
      this.sidenavOpen = true;
    }
  }

  toggleSidenav() {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
      this.sidenavOpen = false;
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
      this.sidenavOpen = true;
    }
  }

  closeSidenav() {
    document.body.classList.remove("g-sidenav-pinned");
    document.body.classList.remove("g-sidenav-show");
    document.body.classList.add("g-sidenav-hidden");
    this.sidenavOpen = false;
  }

  onLogout() {
    this.adminService.logout();
  }
  
}